import { render, staticRenderFns } from "./TrendArrow.vue?vue&type=template&id=aa37f19c&"
import script from "./TrendArrow.vue?vue&type=script&lang=js&"
export * from "./TrendArrow.vue?vue&type=script&lang=js&"
import style0 from "./TrendArrow.vue?vue&type=style&index=0&lang=sass&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports